import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import type { FilterWidget } from '@sorare/core/src/lib/filters';

import { SportCustomDecksFilter } from '#src/searchCards/CustomDecksFilter/SportCustomDecksFilter/index.tsx';
import { FILTER, Title } from '#src/searchCards/CustomDecksFilter/index.tsx';

export const widget: FilterWidget = {
  key: FILTER.name,
  type: 'virtualToggle',
  filter: FILTER,
  Component: ({ visible }) => (
    <SportCustomDecksFilter sport={Sport.FOOTBALL} visible={visible} />
  ),
  title: <Title />,
  accordionOptions: { startsOpen: true },
};
